import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { UploadFacadeService } from '@app/@shared/services/upload/upload-facade.service';
import { CduiBaseService } from '@app/auth/cdui-base.service';

@Injectable({
  providedIn: 'root',
})
export class OCREndpointService extends CduiBaseService {
  constructor(private uploadFacadeService: UploadFacadeService, private http: HttpClient, private injector: Injector) {
    super(injector);
  }

  fileUpload(file: File) {
    return this.uploadFacadeService.dynamicFormUploadFiles(file, 1);
  }
  saveOCRGSIandFileMapping(data: any) {
    return this.http.post(this.api?.ocrExtractionUrl, data);
  }

  saveOCRMappingData(data: any) {
    return this.http.post(this.api?.ocrSetMappingUrl, data);
  }

  manualMappedAttribute(data: any) {
    return this.http.post(this.api?.ocrManualMapping, data);
  }

  getOCRMappings(data: any) {
    // get and post both methods are available
    return this.http.post(this.api?.ocrGetMappingUrl, data);
  }
}
